import {combineReducers} from 'redux'
import types from 'actions/types'

const open = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_BULK_SUBSCRIBE_OPEN:
      return true
    case types.CONTACTS_BULK_SUBSCRIBE_CANCEL:
    case types.CONTACTS_BULK_SUBSCRIBE_SUCCESS:
      return false
    default:
      return state
  }
}

const list = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_BULK_SUBSCRIBE_OPEN:
    case types.CONTACTS_BULK_SUBSCRIBE_SET_LIST:
      return action.list
    case types.CONTACT_LISTS_REQUERY_LISTS_SUCCESS: {
      if (state && action.listIds && action.listIds.includes(state.id)) {
        return {
          ...state,
          summary: action.data[state.id],
        }
      }
      return state
    }
    default:
      return state
  }
}

const loading = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_BULK_SUBSCRIBE_ATTEMPT:
      return true
    case types.CONTACTS_BULK_SUBSCRIBE_OPEN:
    case types.CONTACTS_BULK_SUBSCRIBE_CANCEL:
    case types.CONTACTS_BULK_SUBSCRIBE_SUCCESS:
    case types.CONTACTS_BULK_SUBSCRIBE_FAILURE:
      return false
    default:
      return state
  }
}

export default combineReducers({
  open,
  list,
  loading,
})
